import React from "react";
import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

const PARTNERS = ["Carrefour", "JYSK", "Kik", "MoneyGram", "Medstar 2000", "Laser Vision Med", "Toldimed", "Famous Fast Food"];

export default function Partners() {
  const { t } = useLang();
  return (
    <section className="border-y border-gold/10 bg-ink py-16">
      <div className="container-luxe">
        <Reveal className="mb-10 text-center">
          <p className="text-xs uppercase tracking-[0.28em] text-white/40">{t.partners.title}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
            {PARTNERS.map((p) => (
              <span
                key={p}
                data-testid={`partner-${p}`}
                className="font-serif text-lg tracking-wide text-white/35 transition-colors duration-300 hover:text-gold md:text-xl"
              >
                {p}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
